import { HTTPClient } from "@/utils/request.catalog";

export default {
  get: ({ payload }) =>
    HTTPClient.post("/api/Catalogo/DisponibilidadeMovel", payload),
  getJson: () => HTTPClient.get(),
};
